const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  const fallback = defaultMessage
    ? `${defaultMessage} (HTTP ${response.status})`
    : `Request failed (${response.status})`;
  throw new Error(body.detail || body.message || fallback);
};

export async function fetchSectorRatioAnalysis(companyId, periodId, sectorId, sectorRatioPeriodId, basis = 'IFRS') {
  const params = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId),
    basis: String(basis || 'IFRS')
  });
  if (sectorId) {
    params.set('sectorId', String(sectorId));
  }
  if (sectorRatioPeriodId) {
    params.set('sectorRatioPeriodId', String(sectorRatioPeriodId));
  }

  const response = await fetch(`${API_BASE}/api/analysis/sector-ratio?${params.toString()}`, {
    headers: buildHeaders()
  });

  return handleErrors(response, 'Sektorel rasyo analizi alinamadi.');
}

const analysisSectorRatioService = {
  fetchSectorRatioAnalysis
};

export default analysisSectorRatioService;
